<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-reglement-card">
    <div class="card-header">
      <h3 class="text-black fw-semibold">Enregistrer un règlement</h3>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form ref="reglementForm" @submit="addReglement" :validation-schema="reglementSchema">
        <div class="row">

          <!-- 1. Date du règlement -->
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Date du règlement <span class="text-danger">*</span>
              </label>
              <Field name="date" type="datetime-local" :value="getCurrentDateTime()" readonly
                class="form-control shadow-none fs-md-15 text-black" />
              <ErrorMessage name="date" class="text-danger" />
            </div>
          </div>

          <!-- 2. Commande -->
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Commandes non payées <span class="text-danger">*</span>
              </label>
              <Field name="commande" v-slot="{ field }">
                <Multiselect :options="commandesOptions" :searchable="true" track-by="label" label="label"
                  v-model="field.value" v-bind="field" placeholder="Sélectionner la commande"
                  @change="handleCommandeChange" :disabled="!caisseActive" />
              </Field>
              <ErrorMessage name="commande" class="text-danger" />
            </div>
          </div>

          <!-- Montant TTC avec tooltip récapitulatif -->
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Montant TTC <span class="text-danger">*</span>
              </label>

              <div class="tooltip-wrapper">
                <Field name="montantTtc">
                  <input type="number" v-model="montantTtc" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le montant" readonly
                    :disabled="selectedModeReglementLabel?.toUpperCase() === 'ESPECES' && !caisseActive" />
                </Field>

                <div class="tooltip-box" v-if="commandeSelectionnee">
                  <strong>Récapitulatif :</strong>
                  <ul class="mb-0 mt-1">
                    <li>Montant total : {{ commandeSelectionnee.montTTC }} Fcfa</li>
                    <li>Déjà payé : {{ commandeSelectionnee.montantDejaPaye }} Fcfa</li>
                    <li>Restant : {{ commandeSelectionnee.montantRest }} Fcfa</li>
                  </ul>
                </div>
              </div>

            </div>
          </div>
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Montant payé <span class="text-danger">*</span>
              </label>
              <Field name="montantPaye" v-slot="{ field }">
                <input type="text" v-bind="field" v-format-montant v-model="montantPaye"
                  class="form-control shadow-none fs-md-15 text-black" name="montantPaye" />
              </Field>
              <ErrorMessage name="montantPaye" class="text-danger" />
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">Montant Reste à Payer</label>
              <Field name="montantRest" v-slot="{ field }">
                <input type="number" v-bind="field" readonly class="form-control shadow-none fs-md-15 text-black" />
              </Field>
            </div>
          </div>

          <!-- 6. Mode de règlement fixe -->
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black mb-10">
                Mode de règlement <span class="text-danger">*</span>
              </label>
              <Field name="modeReglement" type="hidden" :value="1" />
              <input type="text" value="ESPECES" readonly class="form-control shadow-none fs-md-15 text-black" />
              <ErrorMessage name="modeReglement" class="text-danger" />
            </div>
          </div>

          <!-- 7. Référence Document (toujours visible) -->
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Référence Document 
              </label>
              <Field name="refDocument" v-slot="{ field }">
                <input type="text" v-bind="field" v-model="refDocument"
                  class="form-control shadow-none fs-md-15 text-black" name="refDocument" />
              </Field>
              <ErrorMessage name="refDocument" class="text-danger" />
            </div>
          </div>

          <!-- 8. Champs conditionnels selon mode règlement -->
          <!-- 9. Billetage (si Commande + ESPECES) -->
          <div
            v-if="selectedModeReglementLabel?.toUpperCase() === 'ESPECES' && selectedTypeReglement === 'Commande'"
            class="col-md-12">
            <div class="row">
              <!-- Billetage Encaissement -->
              <div class="col-md-6 mb-md-12">
                <div class="border border-primary mb-5">
                  <div class="row fw-bold py-2" style="background-color: #0a59a4">
                    <div class="col-md-7">
                      <h3 class="h3 fs-4 text-white">Billetage Paiement</h3>
                    </div>
                    <div class="col-md-5">
                      <h3 class="fs-5 text-white" style="text-align: end;font-weight: bold;"
                        v-if="montantTotalEncaissement">{{ montantTotalEncaissement }} Fcfa</h3>
                    </div>
                  </div>
                  <div class="px-3">
                    <div class="row mt-2">
                      <div class="col-md-4"><label class="fw-semibold">Monnaie</label></div>
                      <div class="col-md-4"><label class="fw-semibold">Quantité</label></div>
                      <div class="col-md-4"><label class="fw-semibold">Montant</label></div>
                    </div>
                    <hr class="mt-0" />
                    <template v-for="(billetage, index) in billetageList" :key="index">
                      <div class="container-tight m-0 py-1">
                        <div class="row align-items-center">
                          <div class="col-md-4 px-1">
                            <input name="monnaie" v-model="billetage.libelle" readonly
                              class="form-control compact-input" placeholder="Monnaie" />
                          </div>
                          <div class="col-md-4 px-1">
                            <Field :name="`billetageList[${index}].qteBillet`" type="number" min="0"
                              v-model="billetage.qteBillet"
                              @input="event => handleBilletageInput(event, billetage, 'encaissement')"
                              @keypress="restrictInput($event)" class="form-control compact-input" placeholder="Qté"
                              :disabled="!caisseActive" />
                            <ErrorMessage :name="`billetageList[${index}].qteBillet`"
                              class="text-danger compact-error" />
                          </div>
                          <div class="col-md-4 px-1">
                            <input type="text" v-model="billetage.montant" readonly placeholder="Montant"
                              class="form-control compact-input" />
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>

              <!-- Billetage Sortie / Reliquat -->
              <div class="col-md-6 mb-md-12">
                <div class="border mb-5"
                  :class="montantManquant > 0 ? 'border-indigo-500 bg-indigo-50' : 'border-danger'">
                  <div class="row fw-bold py-2"
                    :style="montantManquant > 0 ? 'background-color: #6366f1; color: white' : 'background-color: #a40a0a'">
                    <div class="col-md-7">
                      <h3 class="h3 fs-4 text-white">
                        {{ montantManquant > 0 ? 'Montant Manquant' : 'Reliquat à Rendre' }}
                      </h3>
                    </div>
                    <div class="col-md-5">
                      <h3 class="fs-5 text-white" style="text-align: end;font-weight: bold;">
                        {{ montantManquant > 0 ? montantManquant : reliquatCalcule }} Fcfa
                      </h3>
                    </div>
                  </div>
                  <div class="px-3" v-if="montantManquant === 0">
                    <div class="row mt-2">
                      <div class="col-md-4"><label class="fw-semibold">Monnaie</label></div>
                      <div class="col-md-4"><label class="fw-semibold">Quantité</label></div>
                      <div class="col-md-4"><label class="fw-semibold">Montant</label></div>
                    </div>
                    <hr class="mt-0" />
                    <template v-for="(billetage, index) in billetageSortieList" :key="index">
                      <div class="container-tight m-0 py-1">
                        <div class="row align-items-center">
                          <div class="col-md-4 px-1">
                            <input name="monnaie" v-model="billetage.libelle" readonly
                              class="form-control compact-input" placeholder="Monnaie" />
                          </div>
                          <div class="col-md-4 px-1">
                            <Field :name="`billetageSortieList[${index}].qteBillet`" type="number" min="0"
                              v-model="billetage.qteBillet"
                              @input="event => handleBilletageInput(event, billetage, 'sortie')"
                              @blur="() => { if (!billetage.qteBillet) billetage.qteBillet = 0 }"
                              @keypress="restrictInput($event)" class="form-control compact-input" placeholder="Qté"
                              :disabled="!caisseActive" />
                            <ErrorMessage :name="`billetageSortieList[${index}].qteBillet`"
                              class="text-danger compact-error" />
                          </div>
                          <div class="col-md-4 px-1">
                            <input type="text" v-model="billetage.montant" readonly placeholder="Montant"
                              class="form-control compact-input" />
                          </div>
                        </div>
                      </div>
                    </template>
                    <div v-if="montantTotalSortie > reliquatCalcule" class="text-danger mt-2">
                      Le billetage de sortie ({{ montantTotalSortie }} Fcfa) dépasse le reliquat
                      ({{ reliquatCalcule }} Fcfa).
                    </div>
                  </div>
                  <div class="px-3 py-4 text-center" v-else>
                    <i class="fa fa-exclamation-triangle fa-3x text-warning mb-3"></i>
                    <p class="mb-2 text-dark fw-bold">Paiement Partiel</p>
                    <p class="mb-0 text-muted">
                      Il manque encore <strong class="text-warning">{{ montantManquant }} Fcfa</strong>
                    </p>
                    <p class="mb-0 text-muted small mt-2">Le client pourra compléter le paiement plus tard</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Reliquat à retourner -->
            <div class="row mt-3">
              <div class="col-md-10"></div>
              <div class="col-md-2">
                <div class="form-group mb-2">
                  <label class="form-label fw-semibold mb-1 text-start d-block">Reliquat à retourner</label>
                  <input type="number" class="form-control form-control-sm shadow-none text-start"
                    v-model.number="reliquatRetourner" readonly :class="{ 'is-warning': reliquatRetourner > 0 }" />
                  <div v-if="reliquatRetourner > 0" class="text-black mt-2">
                    Reliquat non rendu : {{ reliquatRetourner }} Fcfa.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 11. Boutons -->
          <div class="col-md-12 mt-3">
            <div class="d-flex align-items-center">
              <button ref="submitButton" class="btn btn-primary me-3" type="submit">
                Enregistrer le règlement
              </button>
              <router-link to="/reglements/liste-reglements" class="btn btn-danger">
                <i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative"></span>Annuler
              </router-link>
            </div>
          </div>

        </div>
      </Form>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, onMounted, ref, computed, watch, reactive } from 'vue';
import { Form, Field, ErrorMessage, useForm } from 'vee-validate';
import * as Yup from 'yup';
import ApiService from '@/services/ApiService';
import { error, monSwal, success } from '@/utils/utils';
import Multiselect from '@vueform/multiselect/src/Multiselect';
import router from '@/router';
import { useAuthStore } from '@/services/auth';


interface BilletageForm {
  libelle: string;
  qteBillet: number;
  montant: number;
  monnaie: number;
  valueAct: number;
}

export default defineComponent({
  name: "AddReglement",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
  },

  setup: () => {
    const modeReglement = ref(1);
    const selectedModeReglementLabel = ref<string>('ESPECES');
    const selectedTypeReglement = ref<string>('Commande');
    // Schéma de validation dynamique
    const reglementSchema = computed(() => {
      const schema: any = {
        date: Yup.string().required('La date du règlement est obligatoire'),
        //refDocument: Yup.string().required('La référence est obligatoire'),
        refDocument: Yup.string().notRequired(),
        montantPaye: Yup.string()
          .required('Le montant payé est obligatoire')
          .typeError('Veuillez entrer un nombre')
          .min(1, 'Le montant payé doit être supérieur à 0')
          .test(
            'montant-max',
            'Le montant payé ne peut pas dépasser le reste à payer',
            function (value) {
              return true;
            }
          ),
        modeReglement: Yup.number().oneOf([1]).required('Le mode de règlement est obligatoire'),
      };
      schema.commande = Yup.number().required('La commande est obligatoire');

      if (selectedTypeReglement.value === 'Commande') {
        schema.montantTtc = Yup.number()
          .typeError('Le montant doit être un nombre valide')
          .required('Le montant est obligatoire')
          .min(0, 'Le montant doit être positif');

        schema.billetageList = Yup.array().when('modeReglement', {
          is: 1,
          then: (schema) =>
            schema.of(
              Yup.object().shape({
                qteBillet: Yup.number()
                  .transform((value, originalValue) =>
                    originalValue === '' || originalValue === null ? 0 : value
                  )
                  .typeError('La quantité doit être un nombre')
                  .required('La quantité est obligatoire')
                  .integer('La quantité doit être un entier')
                  .min(0, 'La quantité ne peut pas être négative')
                  .default(0)
              })
            ).required('Les encaissements sont obligatoires pour le paiement en espèces')
              .test(
                'encaissement-min',
                'Le total encaissé doit être supérieur à 0',
                function () {
                  const encaissement = montantTotalEncaissement.value || 0;
                  return encaissement > 0;
                }
              ),
          otherwise: (schema) => schema.notRequired()
        });
        schema.billetageSortieList = Yup.array().when('modeReglement', {
          is: 1,
          then: (schema) =>
            schema.of(
              Yup.object().shape({
                qteBillet: Yup.number()
                  .transform((value, originalValue) =>
                    originalValue === '' || originalValue === null ? 0 : value
                  )
                  .typeError('La quantité doit être un nombre')
                  .required('La quantité est obligatoire')
                  .integer('La quantité doit être un entier')
                  .min(0, 'La quantité ne peut pas être négative')
                  .default(0)
              })
            ).required('Les reliquats sont obligatoires pour le paiement en espèces')
              .test(
                'reliquat-not-exceed',
                'Le total du billetage de sortie ne peut pas dépasser le reliquat',
                function () {
                  const sortie = montantTotalSortie.value || 0;
                  const reliquat = reliquatCalcule.value || 0;
                  return sortie <= reliquat;
                }
              ),
          otherwise: (schema) => schema.notRequired()
        });
        schema.reliquatRetourner = Yup.number()
          .typeError('Le reliquat à retourner doit être un nombre valide')
          .min(0, 'Le reliquat à retourner ne peut pas être négatif')
          .test(
            'reliquat-retourner-match',
            'Le reliquat à retourner doit correspondre au calcul',
            function () {
              const reliquat = reliquatCalcule.value || 0;
              const sortie = montantTotalSortie.value || 0;
              const expectedReliquatRetourner = reliquat - sortie >= 0 ? reliquat - sortie : 0;
              return reliquatRetourner.value === expectedReliquatRetourner;
            }
          );
      }
      return Yup.object().shape(schema);
    });

    // Fonction pour obtenir la date et l'heure actuelles
    function getCurrentDateTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    }
    const { values } = useForm()

    // Variables réactives
    const submitButton = ref<HTMLButtonElement | null>(null);
    const montantPaye = ref('');
    const montantRestPaye = ref('');
    const billetageList = reactive<BilletageForm[]>([]);
    const billetageSortieList = reactive<BilletageForm[]>([]);
    const monnaieList = ref<any[]>([]);
    const montantTotalEncaissement = ref<number | null>(null);
    const montantTotalSortie = ref<number | null>(null);
    const commandesOptions = ref([]);
    const reliquatRetourner = ref(0);
    const caisseId = ref<number | null>(null);
    const showCaisseClosedMessage = ref<boolean>(false);
    const caisseActive = ref<boolean>(false);
    const montantTtc = ref<number | null>(null);
    const typeOperationId = ref<number>(1);
    const reglementForm = ref<InstanceType<typeof Form> | null>(null);
    const selectedCommande = ref(null);
    const { resetForm } = useForm();
    const store = useAuthStore();

    const montantManquant = computed(() => {
      if (!montantTotalEncaissement.value || !montantTtc.value) {
        return 0;
      }
      const difference = montantTtc.value - montantTotalEncaissement.value;
      return difference > 0 ? difference : 0;
    });

    const veriferCaisseOuverte = async () => {
      store.loadCaisseFromStorage();
      console.log("storeee", store.isCaisseOuverte);

      if (store.isCaisseOuverte()) {
        caisseActive.value = true;
        caisseId.value = store.getCaisseId();
        showCaisseClosedMessage.value = false;
        console.log("Caisse déjà en session:", caisseId.value);
        return;
      }

      try {
        const response = await ApiService.get("/ouvfer");
        console.log("Réponse /ouvfer:", response.data);

        if (response.data.code === 200) {
          if (response.data.data) {
            const ouvertureData = response.data.data;
            console.log("je suisiiiiiiiii", ouvertureData);
            store.setCaisseOuverte(ouvertureData);
            caisseActive.value = true;
            caisseId.value = ouvertureData.id;
            showCaisseClosedMessage.value = false;

            console.log("Caisse ouverte chargée depuis API:", {
              ouvertureId: ouvertureData.id,
              caisseId: ouvertureData.caisse.id,
              nom: ouvertureData.caisse.nom
            });
          } else {
            caisseActive.value = false;
            caisseId.value = null;
            showCaisseClosedMessage.value = false;
          }
        }
      } catch (err: any) {
        caisseActive.value = false;
        caisseId.value = null;
        const msg = err.response?.data?.message || "Impossible de vérifier la caisse";
        error(msg);
      }
    };

    const ouvrirCaisse = () => {
      router.push({ name: 'AddOuvFermPage' })
    };

    const montantError = computed(() => {
      if (selectedModeReglementLabel.value?.toUpperCase() !== 'ESPECES') {
        return null;
      }

      if (montantTtc.value === null || montantTotalEncaissement.value === null) {
        return null;
      }

      const encaissement = montantTotalEncaissement.value || 0;
      const ttc = montantTtc.value || 0;
      const sortie = montantTotalSortie.value || 0;
      const reliquat = encaissement - ttc;

      if (reliquat > 0 && sortie > reliquat) {
        return `Le billetage de sortie (${sortie} Fcfa) ne peut pas dépasser le reliquat (${reliquat} Fcfa)`;
      }

      return null;
    });

    const getAllMonnaies = async () => {
      try {
        const res = await ApiService.get("/all/monnaies");
        monnaieList.value = res.data.data.data;
        billetageList.splice(0, billetageList.length);
        billetageSortieList.splice(0, billetageSortieList.length);
        monnaieList.value.forEach((element) => {
          const billetage = {
            libelle: element.libelle,
            montant: 0,
            valueAct: element.valeur,
            monnaie: element.id,
            qteBillet: 0,
          };
          billetageList.push({ ...billetage });
          billetageSortieList.push({ ...billetage });
        });
      } catch (err) {
        console.error("Erreur lors de la récupération des monnaies:", err);
        error("Erreur lors de la récupération des monnaies");
      }
    };

    const verifierBillets = async (): Promise<boolean> => {
      if (reliquatCalcule.value <= 0) return true;

      const billetsAVerifier = billetageSortieList
        .filter(b => b.qteBillet > 0)
        .map(b => ({
          monnaie: b.valueAct,
          qteBillet: b.qteBillet
        }));

      if (billetsAVerifier.length === 0) return true;

      try {
        const response = await ApiService.post('/caisse/verifier-billets', {
          billets: billetsAVerifier
        });

        if (!response.data.success) {
          error(response.data.message);
          return false;
        }

        return true;
      } catch (err) {
        error("Erreur lors de la vérification des billets en caisse");
        return false;
      }
    };
    const fetchCommande = async () => {
    try {
        const response = await ApiService.get('/commandesNonPaye');
        console.log("vallll", response);
        const commandeDonnees = response.data.data;
        
        commandesOptions.value = commandeDonnees.map((commande) => {
            const montantDejaPaye = commande.montTTC - commande.montantRest;
            // const pourcentagePaye = ((montantDejaPaye / commande.montTTC) * 100).toFixed(0);

            const client = commande?.client;

            // Détermination du nom d'affichage du client :
            // 1. Si nom/prénom existant(s), on les combine.
            // 2. Sinon, on utilise la raison sociale (ou dénomination).
            const nomPrenom = `${client?.nomClient ?? ''} ${client?.prenomClient ?? ''}`.trim();
            const nomClient = nomPrenom !== '' 
                ? nomPrenom 
                : (client?.raisonSociale || client?.denomination || 'Client inconnu');

            return {
                value: commande.id,
                label: `${commande.refCom} - ${nomClient} - Reste: ${commande.montantRest} Fcfa`,
                montTTC: commande.montTTC,
                montantRest: commande.montantRest,
                montantDejaPaye: montantDejaPaye,
            };
        });

        console.log("Commandes options :", commandesOptions.value);
        console.log("Première commande :", commandesOptions.value[0]);

    } catch (error) {
        console.error('Erreur lors de la récupération des commandes:', error);
    }
};

    const commandeSelectionnee = computed(() => {
      if (!selectedCommande.value) return null;
      return commandesOptions.value.find(cmd => cmd.value === selectedCommande.value);
    });

    const reliquatCalcule = computed(() => {
      if (!montantTotalEncaissement.value || !montantTtc.value) {
        return 0;
      }
      const difference = montantTotalEncaissement.value - montantTtc.value;
      return difference > 0 ? difference : 0;
    });

    const calculateReliquatRetourner = () => {
      const sortie = montantTotalSortie.value || 0;
      const reliquat = reliquatCalcule.value || 0;
      reliquatRetourner.value = reliquat - sortie >= 0 ? reliquat - sortie : 0;
    };

    //  const handleBilletageInput = (event: Event, billetage: BilletageForm, type: 'encaissement' | 'sortie') => {
    //   const newValue = Number((event.target as HTMLInputElement).value);
    //   billetage.qteBillet = isNaN(newValue) || newValue < 0 ? 0 : newValue;
    //   updateMontant(billetage, type);
    //   calculateMontantRest();
    // };

    const handleBilletageInput = async (event: Event, billetage: BilletageForm, type: 'encaissement' | 'sortie') => {
      const newValue = Number((event.target as HTMLInputElement).value);
      billetage.qteBillet = isNaN(newValue) || newValue < 0 ? 0 : newValue;
      updateMontant(billetage, type);
      calculateMontantRest();

      if (type === 'sortie' && billetage.qteBillet > 0) {
        await verifierBillets();
      }
    };

    const updateMontant = (billetage: BilletageForm, type: 'encaissement' | 'sortie') => {
      billetage.montant = billetage.qteBillet * billetage.valueAct || 0;
      if (type === 'encaissement') {
        calculateTotalEncaissement();
      } else {
        calculateTotalSortie();
      }
    };

    // const calculateTotalEncaissement = () => {
    //   const total = billetageList.reduce((total, billetage) => {
    //     return total + (billetage.montant || 0);
    //   }, 0);
    //   montantTotalEncaissement.value = total || null;

    //   if (reglementForm.value) {
    //     reglementForm.value.setFieldValue('montantPaye', total);
    //   }
    //   montantPaye.value = total.toString();

    //   calculateReliquatRetourner();
    // };

    const calculateTotalEncaissement = () => {
      const total = billetageList.reduce((total, billetage) => {
        return total + (billetage.montant || 0);
      }, 0);

      montantTotalEncaissement.value = total || null;

      const montantFinal = Math.min(total, montantTtc.value || total);

      if (reglementForm.value) {
        reglementForm.value.setFieldValue('montantPaye', montantFinal);
      }
      montantPaye.value = montantFinal.toString();

      calculateReliquatRetourner();
    };


    const calculateTotalSortie = () => {
      const total = billetageSortieList.reduce((total, billetage) => {
        return total + (billetage.montant || 0);
      }, 0);
      montantTotalSortie.value = total || null;
      calculateReliquatRetourner();
    };

    watch([montantTotalEncaissement, montantTotalSortie, montantTtc], () => {
      calculateReliquatRetourner();
    });

    const cancelOperation = async () => {
      const confirmed = await monSwal(
        "Voulez-vous vraiment annuler l'opération ?",
        "Confirmer",
        "btn btn-primary",
        "Annuler",
        "L'opération a été annulée !"
      );
      if (confirmed) {
        if (reglementForm.value) {
          resetForm();
        } else {
          console.warn('billetageForm n\'est pas défini');
        }
        billetageList.length = 0;
        billetageSortieList.length = 0;
        //montant.value = null;
        montantTtc.value = null;
        montantPaye.value = null;
        reliquatRetourner.value = 0;
        selectedCommande.value = null;
        selectedModeReglementLabel.value = 'ESPECES';
        modeReglement.value = 1;
        await getAllMonnaies();
        if (reglementForm.value) {
          reglementForm.value.setFieldValue('modePaiement', 1);
        }
        router.push({ name: 'AddPaiement' });
      }
    };

    watch(billetageList, () => {
      calculateTotalEncaissement();
    }, { deep: true });

    watch(billetageSortieList, () => {
      calculateTotalSortie();
    }, { deep: true });


    const handleCommandeChange = (value: any) => {
      console.log("Valeur reçue :", value);
      selectedCommande.value = value;
      if (!value) {
        montantTtc.value = null;
        montantPaye.value = null;
        return;
      }

      const commande = commandesOptions.value.find(
        (cmd: any) => cmd.value === value
      );

      console.log("infoooooooooiciiii", commande);

      if (commande) {
        montantTtc.value = commande.montantRest;
        if (reglementForm.value) {
          reglementForm.value.setFieldValue('montantTtc', commande.montantRest);
        }

        if (selectedModeReglementLabel.value?.toUpperCase() === 'ESPECES') {
          montantPaye.value = commande.montantRest;
          if (reglementForm.value) {
            reglementForm.value.setFieldValue('montantPaye', commande.montantRest);
            reglementForm.value.setFieldValue('montantRest', 0);
          }
        } else {
          montantPaye.value = null;
          if (reglementForm.value) {
            reglementForm.value.setFieldValue('montantRest', commande.montantRest);
          }
        }
      } else {
        montantTtc.value = null;
        montantPaye.value = null;
      }
    };


    const calculateMontantRest = () => {
      const montantTtcValue = montantTtc.value || 0;

      if (selectedModeReglementLabel.value?.toUpperCase() === 'ESPECES') {
        const encaissement = montantTotalEncaissement.value || 0;
        const montantRestValue = montantTtcValue - encaissement;
        if (reglementForm.value) {
          reglementForm.value.setFieldValue('montantRest', montantRestValue >= 0 ? montantRestValue : 0);
        }
      } else {
        const montantPayeValue = parseInt(montantPaye.value.toString().replace(/\s+/g, '') || '0');
        const montantRestValue = montantTtcValue - montantPayeValue;
        if (reglementForm.value) {
          reglementForm.value.setFieldValue('montantRest', montantRestValue >= 0 ? montantRestValue : 0);
        }
      }
    };


    const addReglement = async (values: any, { resetForm }: any) => {
      if (submitButton.value) submitButton.value.disabled = true;

      if (selectedTypeReglement.value === 'Commande') {
        await veriferCaisseOuverte();
        if (!caisseActive.value) {
          error("La caisse a été fermée. Veuillez rouvrir une caisse avant de continuer.");
          submitButton.value!.disabled = false;
          return;
        }
      }

      if (selectedModeReglementLabel.value?.toUpperCase() === 'ESPECES'
        && selectedTypeReglement.value === 'Commande') {
        const billetsOk = await verifierBillets();
        if (!billetsOk) {
          submitButton.value!.disabled = false;
          return;
        }
      }

      const reglementData: any = {
        date: values.date,
        montantPaye: parseInt((montantPaye.value.replace(/\s+/g, '')).toString()),
        refDocument: values.refDocument,
        modeReglement: values.modeReglement,
      };

      reglementData.commande = values.commande;
      reglementData.montantTtc = montantTtc.value;
      reglementData.montantRest = values.montantRest;
      reglementData.caisseId = caisseId.value;
      reglementData.billetagesEncaissement = billetageList;
      reglementData.montantTotalEncaissement = montantTotalEncaissement.value;
      reglementData.billetagesSortie = billetageSortieList;
      reglementData.montantTotalSortie = montantTotalSortie.value || 0;
      reglementData.reliquat = reliquatCalcule.value;
      reglementData.reliquatRetourner = reliquatRetourner.value;
      reglementData.montantDu = commandeSelectionnee.value?.montTTC;

      console.log("Données envoyées au serveur :", reglementData);

      try {
        const response = await ApiService.post("/reglements", reglementData);
        if (response.data.code === 201) {
          success(response.data.message);
          resetForm();
          router.push({ name: "ListeReglement" });
        }
      } catch (err) {
        submitButton.value!.disabled = false;
        error(err.response?.data?.message || err.message || "Une erreur est survenue");
      }
    };

    onMounted(async () => {

      await veriferCaisseOuverte();
      await getAllMonnaies();
      fetchCommande();
    });

    const restrictInput = (event: KeyboardEvent) => {
      if (!/^[0-9]*$/.test(event.key) && event.key !== 'Backspace') {
        event.preventDefault();
      }
    };

    return {
      reglementSchema,
      addReglement,
      getCurrentDateTime,
      submitButton,
      montantPaye,
      modeReglement,
      montantRestPaye,
      billetageList,
      billetageSortieList,
      montantTotalEncaissement,
      montantTotalSortie,
      restrictInput,
      handleBilletageInput,
      commandesOptions,
      handleCommandeChange,
      cancelOperation,
      reglementForm,
      reliquatCalcule,
      reliquatRetourner,
      showCaisseClosedMessage,
      ouvrirCaisse,
      caisseActive,
      caisseId,
      montantManquant,
      commandeSelectionnee,
      selectedTypeReglement,
      selectedModeReglementLabel,
      montantTtc,
      selectedCommande,
    };
  },
});
</script>

<style scoped>
.error {
  color: red;
}

.montant-total {
  text-align: left;
  font-weight: bold;
  font-size: 1rem;
  margin-top: 8px;
}

.text-danger {
  font-size: 0.75rem;
  color: #dc3545;
}

.text-warning {
  font-size: 0.75rem;
  color: #ffc107;
}

.compact-input {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  height: 30px;
}

.compact-error {
  font-size: 0.75rem;
  margin-top: 2px;
}

.container-tight {
  margin: 0;
  padding: 2px 0;
}

.is-warning {
  border-color: #ffc107;
}

.disabled-form {
  opacity: 0.6;
  pointer-events: none;
}

.alert-warning {
  background-color: #fff3cd;
  border-color: #ffeeba;
  color: #856404;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 15px;
}

.border-warning {
  border-color: #ff9800 !important;
  border-width: 2px !important;
}

.fa-exclamation-triangle {
  color: #ff9800;
}

.tooltip-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
}

.tooltip-box {
  display: none;
  position: absolute;
  top: 110%;
  left: 0;
  z-index: 999;
  background-color: #fff;
  border: 1px solid #0a59a4;
  border-radius: 6px;
  padding: 10px 14px;
  min-width: 280px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  font-size: 0.85rem;
  color: #333;
}

/* ✅ Afficher au hover */
.tooltip-wrapper:hover .tooltip-box {
  display: block;
}
</style>